// client/customer/src/utils/reservation/by-Date/fetchServicesForStaff.ts
import apiConfig from '../../../apiConfig';

export type ServiceForStaff = {
  service_id: number;
  service_name: string;
  price: number;
  duration_minutes: number;
  category_id: number | null;
  category_name: string | null;
  color_class: string | null;
};

export const fetchServicesForStaff = async (
  storeId: number,
  staffId: number
): Promise<ServiceForStaff[]> => {
  const params = new URLSearchParams({
    store_id: String(storeId),
    staff_id: String(staffId),
  });

  const res = await fetch(
    `${apiConfig.baseURL}/api/customer-app/reservation/by-date/services?${params.toString()}`
  );

  if (!res.ok) {
    throw new Error('Failed to fetch services for staff');
  }

  const data = (await res.json()) as ServiceForStaff[];
  return data;
};
